<template>
  <div>
    <div>
      <!-- Name Input  -->
      <div class="col form-group mb-4">
        <input
          ref="nameInput"
          id="name"
          v-model="obj.firstName"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="obj.name ? obj.name : placeholders.fullName"
          type="text"
        />
      </div>

      <!-- Last Name Input -->
      <div class="col form-group mt-5">
        <input
          ref="nameInput"
          id="socialName"
          v-model="obj.socialName"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="placeholders.beCalled"
          type="text"
          @keyup.enter="validateFields"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Name',
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
    placeholders() {
      return {
        fullName: this.$t('name.fullName'),
        beCalled: this.$t('name.beCalled'),
      }
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  methods: {
    ...mapMutations([
      'addRegistrationError',
      'clearRegistrationErrors',
      'updateRegistrationObject',
    ]),
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.$t('common.attention'),
        variant: variant,
        solid: true,
      })
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      let nameFull = this.obj.firstName.split(' ')

      if (nameFull.length <= 1) {
        hasErrors = true
        const warningMsg = this.$t('name.fullNameRequired')
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')
      }

      if (!this.obj.firstName) {
        hasErrors = true
        const warningMsg = this.$t('name.firstNameRequired')
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')
      }

      if (!this.obj.socialName) {
        hasErrors = true
        const warningMsg = this.$t('name.socialNameRequired')
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },
  },
  mounted() {
    // Creates a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    document.getElementById('name').focus()
  },
}
</script>
